module.exports = __webpack_public_path__ + "img/dairy_free.de13427d.svg";